import { render, staticRenderFns } from "./CostConsultation.vue?vue&type=template&id=66d3293c&scoped=true&"
import script from "./CostConsultation.vue?vue&type=script&lang=js&"
export * from "./CostConsultation.vue?vue&type=script&lang=js&"
import style0 from "./CostConsultation.vue?vue&type=style&index=0&id=66d3293c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3293c",
  null
  
)

export default component.exports